<template>
	<div id="systemmodule">
		<HrrBreadcrumb PMname="用户权限管理" CMname="模块管理" />
		<HrrDetailLayout>
			<template slot="head" >
				{{title}}
			</template>
			<template slot="Form" >
				<el-form status-icon :model="form" ref="form" :rules="rules" label-width="100px" class="el-form-module" :hide-required-asterisk="isView" >
					<el-form-item label="模块名称：" prop="moduleName">
						<el-input v-model="form.moduleName" v-if="isAdd||isEdit"></el-input>
						<span v-if="isView">
							{{form.moduleName}}
						</span>
					</el-form-item>
					<el-form-item label="模块代码：" prop="moduleCode">
						<el-input v-model="form.moduleCode" v-if="isAdd||isEdit"></el-input>
						<span v-if="isView">
							{{form.moduleCode}}
						</span>
					</el-form-item>
					<el-form-item label="模块Icon：" prop="moduleIcon">
						<el-input v-model="form.moduleIcon" v-if="isAdd||isEdit"></el-input>
						<span v-if="isView">
							{{form.moduleIcon}}
						</span>
					</el-form-item>
					<el-form-item label="模块地址：" prop="moduleUrl">
						<el-input v-model="form.moduleUrl" v-if="isAdd||isEdit"></el-input>
						<span v-if="isView">
							{{form.moduleUrl}}
						</span>
					</el-form-item>
					<el-form-item label="父级模块：" >
						<el-checkbox v-model="ishaveparent" v-if="isAdd||isEdit" v-show="isAdd||(form.parentId!=null)" @change="parentchange" >选择父级</el-checkbox>&nbsp;
						<el-select v-model="form.parentId" placeholder="请选择父级模块" v-if="isAdd||isEdit" v-show="ishaveparent">
							<el-option v-for="item in parentData"
							:key="item.moduleId"
							:label="item.moduleName"
							:value="item.moduleId" ></el-option>
						</el-select>
						<span v-if="isView">
							{{form.parentName}}
						</span>
					</el-form-item>
					<el-form-item label="排序：" prop="sort">
						<el-input-number v-model="form.sort" controls-position="right" :min="1" v-if="isAdd||isEdit"></el-input-number>
						<span v-if="isView">
							{{form.sort}}
						</span>
					</el-form-item>
					<el-form-item label="状态：" prop="status">
						<el-radio-group v-model="form.status" >
							<el-radio :label="1" :disabled="isView">启用</el-radio>
							<el-radio :label="0" :disabled="isView">禁用</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</template>
			<template slot="buttons" >
				<el-button type="primary" @click="submitMForm('form')" v-if="isAdd||isEdit">提 交</el-button>
				<el-button  @click="resetMForm('form')" v-if="isAdd||isEdit">重 置</el-button>
				<el-button type="info" @click="returnMForm()" >返 回</el-button>
			</template>
		</HrrDetailLayout>
	</div>
</template>
<script>
	export default {
		name: 'moduledetail',
		data(){
			return{
				form:{
					moduleId:0,
					moduleName:"",
					moduleCode:"",
					moduleIcon:"",
					moduleUrl:"",
					parentId:"",
					parentName:"",
					status:1,
					sort:0
				},
				rules:{
					moduleName:[ { required: true, message: '请输入模块名称' , trigger: 'blur'}],
					moduleCode:[ { required: true, message: '请输入模块代码' , trigger: 'blur'}],
					moduleUrl:[ { required: true, message: '请输入模块地址' , trigger: 'blur'}],
					sort:[ { required: true, message: '请输入排序数字' , trigger: 'blur'}]
				},
				title:"",
				isEdit:true,
				isAdd:false,
				isView:false,
				ishaveparent:false,
				parentData:[]
			}
		},
		methods:{
			submitMForm:function(formName){
				this.$refs[formName].validate((valid) =>{
					if (valid) {
						var loading = this.$loading({
							lock: true,
							text: '提交中...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						var Vuethis=this;
						var apiUrl=this.$api.system.module+(this.isAdd?"":"/"+this.form.moduleId);
						var m = this.isAdd ? "POST" : "PUT";
						this.$hrraxios({
							method: m,
                            url: apiUrl,
                            data:this.form})
						.then(function(response){
							loading.close();
							var data=response.data;
							if(data.Success==true)
							{
								Vuethis.$alert("提交成功！",{callback:action=>{
									Vuethis.$router.push({path:'/system/module/'});
								}});
							}else{
								Vuethis.$message({message:data.Prompt,type:"error"});
							}
						}).catch(function(error){
							loading.close();
							console.log(error);
						})
					} else {
						return false;
					}
				});
			},
			resetMForm:function(formName) {
				this.$refs[formName].resetFields();
			},
			returnMForm:function(){
				this.$router.go(-1);
			},
			initData:function(){
				this.isView=false;
				this.isEdit=false;
				this.isAdd=false;
				var Hrrtype=this.$route.params.type; //类型
				var row=this.$route.meta.row;
				var info="模块信息";
				if(Hrrtype!="add"){
					this.form=row;
					this.$route.meta.row=null;
				}
				if(Hrrtype=="view"){
					this.title="查看"+info;
					this.isView=true;
				}
				if(Hrrtype=="edit"){
					this.title="编辑"+info;
					this.isEdit=true;
					this.ishaveparent=(this.form.parentId!=null)?true:false;

				}
				if(Hrrtype=="add"){
					this.title="新增"+info;
					this.isAdd=true;
				}
				var myVuethis=this;
				this.$hrraxios.get(this.$api.system.moduleOnlyparent)
				.then((response)=>{
					var data=response.data;
					if(data.Success==true){
						myVuethis.parentData=data.Data;
					}else{
						myVuethis.$message.error("数据初始化失败,请联系管理员");
					}
				})
				.catch((error)=>{
					console.log(error);
				})
			},
			parentchange(val){
				if(val==false){
					if(this.isAdd==true){
						this.form.parentId="";
					}
				}
			}
		},
		created:function(){
	        this.$route.meta.row!=undefined?localStorage.setItem("row",JSON.stringify(this.$route.meta.row)):"";
        	localStorage.getItem("row")!=undefined? this.$route.meta.row=JSON.parse(localStorage.getItem("row")):"";
			this.initData();
		}
	}
</script>
<style >
.el-form-module{width:500px;}
</style>